@if (_calculatedPrice) {
  @if(_calculatedPrice?.discountincvat === 0){
    @if(_calculatedPrice?.priceincvat === 0 && !_couponcodeItem && !_compensationItem){
      <small>{{'order.product_currently_not_available' | translate}}</small>
    }@else {
      @if (hideSmallTag) {
        {{_calculatedPrice?.priceincvat |currency: 'EUR':'symbol':'.2-2':'nl'}}
      } @else {
        <div @collapse class="flex flex-col items-end text-right">
          <small>{{_calculatedPrice?.priceincvat |currency: 'EUR':'symbol':'.2-2':'nl'}}</small>
        </div>
      }
    }
  }@else {
      @if (hideSmallTag) {
        <div class="flex gap-[0.25rem] text-black">
          <span class="line-through"> {{_calculatedPrice?.priceincvat + _calculatedPrice?.discountincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} </span>
          <strong>{{_calculatedPrice?.priceincvat   |currency: 'EUR':'symbol':'.2-2':'nl'}}</strong>
        </div>
      } @else {
        <div @collapse class="flex flex-col items-end text-right">
          <small><i class="line-through"> {{_calculatedPrice?.priceincvat + _calculatedPrice?.discountincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} </i></small>
          <strong><small>{{_calculatedPrice?.priceincvat   |currency: 'EUR':'symbol':'.2-2':'nl'}}</small></strong>
        </div>
      }
    
  }
}
